import api from '@/api';

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function initialState() {
  return {
    categories: [],
    currentCategory: {
      name: null,
      description: null,
    },
  };
}

export default {
  namespaced: true,

  state: initialState,

  getters: {
    //
  },

  mutations: {
    setCategories(state, categories) {
      state.categories = categories;
    },

    setCurrentCategory(state, category) {
      state.currentCategory = Object.assign({}, category);
    },
  },

  actions: {
    // CATEGORIES CRUD ACTIONS
    list({ commit, state, rootState }) {
      commit('setCategories', []);

      api()
        .get(`${rootState.documents.apiEndpoint}/categories`)

        .then((response) => {
          commit('setCategories', response.data.data.category);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'category')) {
            commit('setCategories', error.response.data.data.category);
          }
        });
    },

    read({ commit, state, rootState }, categoryId) {
      commit('setCurrentCategory', {});

      return new Promise((resolve, reject) => {
        api()
          .get(`${rootState.documents.apiEndpoint}/category/${categoryId}`)
          .then((response) => {
            commit('setCurrentCategory', response.data.data.category[0]);
            resolve();
          })
          .catch((error) => {
            if (error.response && hasProp(error.response.data.data, 'category')) {
              commit(
                'setCurrentCategory',
                error.response.data.data.category[0],
              );
            } else {
              reject(error.response);
            }
          });
      });
    },

    create({
      commit, state, dispatch, rootState,
    }) {
      const categoryData = state.currentCategory;
      return new Promise((resolve, reject) => {
        api()
          .put(`${rootState.documents.apiEndpoint}/category`, { category: categoryData })
          .then((response) => {
            const category = response.data.data.category[0];
            dispatch('list');
            resolve(response.data);
            // Send notification
            dispatch('notifications/create', {
              body: `The category <b>${category.name}</b> was created`,
              type: 'success',
            }, { root: true });
          })
          .catch((error) => {
            if (error.response && hasProp(error.response.data.meta, 'duplicate_category')) {
              const duplicateCategory = error.response.data.meta.duplicate_category;
              dispatch('notifications/create', {
                title: 'Error!',
                body: `A category with the name <b>${duplicateCategory.name}</b> already exists`,
                type: 'danger',
                timeout: 12000,
              }, { root: true });
            }
            reject(error.response.data);
          });
      });
    },

    update({
      commit, state, dispatch, rootState,
    }, categoryId) {
      const category = state.currentCategory;
      return new Promise((resolve, reject) => {
        api()
          .put(`${rootState.documents.apiEndpoint}/category/${categoryId}`, { category })
          .then((response) => {
            dispatch('list');
            const category = response.data.data.category[0];
            resolve(response.data.data);
            // Send notification
            dispatch('notifications/create', {
              body: `The category <b>${category.name}</b> was updated`,
              type: 'success',
            }, { root: true });
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },

    delete({
      commit, state, dispatch, rootState,
    }, categoryId) {
      return new Promise((resolve, reject) => {
        api()
          .delete(`${rootState.documents.apiEndpoint}/category/${categoryId}`)
          .then((response) => {
            dispatch('list');
            // resolve(response.data.data);
            // Send notification
            dispatch('notifications/create', {
              body: 'The category was deleted',
              type: 'success',
            }, { root: true });
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
  },
};
